import 'core-js/es/map'
import 'core-js/es/set'
import 'core-js/es/promise'
import 'core-js/es/object'
import 'core-js/web/url-search-params'
import 'core-js/stable/dom-collections/for-each'

import React from 'react'
import { hydrate } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ensureReady, After } from '@jaredpalmer/after'

import routes from './routes'

import Layout from './views/Layout'

import * as serviceWorker from './serviceWorker'

ensureReady(routes).then(data => {
  hydrate(
    <BrowserRouter>
      <Layout userAgent={navigator.userAgent}>
        <After
          data={data}
          routes={routes}
          dynamic={true}
          transitionBehavior="instant"
        />
      </Layout>
    </BrowserRouter>,
    document.getElementById('root')
  )
})

serviceWorker.register()

if (module.hot) {
  module.hot.accept()
}
